import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { DataSource } from '@angular/cdk/collections';
import { MdPaginator, MdSnackBar, MdAutocomplete, MdProgressSpinnerModule } from '@angular/material';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/finally';
import { Configurations } from "../../core/configurations";
import { ClienteSearchModel } from './../../models/clienti/cliente-search.model';
import { ClienteListItemModel } from './../../models/clienti/cliente-list-item.model';
import { ClientiService } from './../../services/clienti.service';
import { PartiteService } from './../../services/partite.service';
import { UtilitiesService } from './../../services/utilities.service';
import { MapService } from '../google-map/map.service';
import { SituazionePartiteClienteList} from '../../models/incassi/partita-list-item.model';
import { ReactiveFormsModule, FormBuilder, FormGroup, Validators, FormControl } from "@angular/forms";
import {CurrencyPipe} from '@angular/common';
import { OverlappingCheckModel, OverlapCheckElement } from '../../models/clienti/overlappingCheckModel';
import { UltimaVersioneApplicativoClientService } from '../../services/ultima-versione-applicativo-client.service';

@Component({
  selector: 'app-clienti-list',
  templateUrl: './clienti-list.component.html',
  styleUrls: ['./clienti-list.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class ClientiListComponent implements OnInit {

  selected: string;
  tdStates: any[];

  isLoading = false;
  clienti: ClienteListItemModel[];
  model: ClienteSearchModel = null;
  dataSource: ClientiDataSource = null;
  displayedColumns = ['zona', 'clienteRagioneSociale', 'clienteCitta', 'clienteIndirizzo', 'partitaIVA',
  'debito', 'situazionePartite' ];
  intorno = false;
  numeroRisultati = 0;

  mapCenter: google.maps.LatLng = new google.maps.LatLng(44.90493,8.9434313);
  zoom: number = 9;
  addingMarkers:boolean=false;
  markerList: google.maps.Marker[];

  @ViewChild(MdPaginator) paginator: MdPaginator;

  constructor(
    // private router: Router,
    private configuration: Configurations,
    private clientiService: ClientiService,
    private partiteService: PartiteService,
    private utilitiesService: UtilitiesService,
    private map: MapService,
    private snackBar: MdSnackBar,
    private cp:CurrencyPipe,
    private _ultimaVersioneClientTipo:UltimaVersioneApplicativoClientService
  ) {
  }

  lista = [];
  /*AUTOCOMPLETE */
  filterStates(val: string) {
    this.model.codiceComune = "";
    if (val && val.length > 3) {
      const filterValue = val.toLowerCase();
      this.utilitiesService.getComuniList(filterValue)
        .subscribe(data => {
          this.lista = data;
        });
      return this.lista;
    }
    return [];
  }

  filterValueStates(val: string) {

    if (val && val.length > 3 && this.lista.length > 0) {
      let scope = this;
      if (this.lista.filter(state => state.descrizione === val)[0]) {
        this.lista.filter(state => state.descrizione === val).map(m => scope.model.codiceComune = m.id);
      }
    }
    console.log(this.model.codiceComune);
  }
  /* FINE AUTOCOMPLETE */


  ngOnInit() {
    //alert("pagina lista clienti");
    this._ultimaVersioneClientTipo.getUltimaVersioneApplicativo()
    .subscribe(data => {
      Configurations.currentVersionCod=data.codice;
      let v=localStorage.getItem('clientVersion');
      if(v===null||v===undefined||v!==data.codice) {
        localStorage.setItem('clientVersion',data.codice);
        alert("Sono state pubblicate delle modifiche nel portale, per poterle caricare verrà indirizzato alla homepage.");
        window.location.href=Configurations.baseUrl;

      }
    });
    //initDatePicker();
    this.model = new ClienteSearchModel();
    this.model.raggio = this.configuration.raggioRicerca;

    setTimeout(function () {
      google.maps.event.trigger(this.map, 'resize');
    }, 600);

    let scope = this;
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(function (position) {
        setTimeout(function () {
          google.maps.event.trigger(this.map, 'resize');
          scope.map.setCenter(new google.maps.LatLng(position.coords.latitude, position.coords.longitude));
          scope.setMyPosition(position.coords.latitude, position.coords.longitude);
        }, 600);

      }, function () {
        scope.showError("Posizione corrente non pervenuta");
      });
    } else {
      // Browser doesn't support Geolocation
      scope.showError("Il browser non supporta la geolocalizzazione");
    }


  }

  search() {
    this.numeroRisultati = 0;
    this.isLoading = true;
    this.map.deleteMarkers();
    this.clientiService.getList(this.model)
      .catch((r: Response, o) => {
        return Observable.throw(r);
      })
      .subscribe((r: ClienteListItemModel[]) => {
        this.clienti = r;
        let mapper: string[];
        //aggiorno lo stato cliente
        this.partiteService.SituazioniPartiteClienti(this.clienti)
         // .finally(() => this.isLoading = false )
          .subscribe((res: SituazionePartiteClienteList[]) => {
            //console.log("risposta situazione partite:"+ JSON.stringify(res));
            for(let element of res){
            //res.body.forEach(function (element) {
              let app = this.clienti.find(cc => cc.codiceClienteAS400 === element.codiceClienteAs400);
              if(app) {
                app.situazionePartite = element.statoPartite;
                app.debitoScaduto=element.totaleDebitoScadute;
                app.debitoScoperto=element.totaleDebitoScoperto;
                app.calcoloDaSanare=element.calcoloDaSanare;
                this.dataSource = new ClientiDataSource(this.clienti, this.paginator, this.model);
                if (r) {
                  this.numeroRisultati = r.length;
                } else {
                  this.numeroRisultati = 0;
                }

              }
            }
            this.showMarkers(this.clienti);
            this.isLoading = false ;
          //);
          });

      });
  }

  setMyPosition(lat, lng) {
    this.model.latitudinePosizione = lat;
    this.model.longitudinePosizione = lng;
    this.map.addMarker(
      new google.maps.LatLng(lat, lng),
      'La tua posizione',
      'Tu sei qui'
    );


  }
  getOverlap( overlapArray:OverlappingCheckModel,lat:number, lng:number):OverlapCheckElement {
    let overlapResponse=null;
    for(let i = 0; i<overlapArray.elements.length&&overlapResponse===null;i++) {
      let overlap = overlapArray.elements[i];
      if(overlap.lat===lat&&overlap.lng===lng) {
        overlapResponse=overlap;
      }
    }
    return overlapResponse;
  }
  showMarkers(clienti: ClienteListItemModel[]) {
    if (clienti) {
      let counter=0;
      this.addingMarkers=true;
      let main=this;
      let totals=0;
      let zoneCounters:any[];
      zoneCounters=[];
      let cpipe=this.cp;
      let overlappingCheck:OverlappingCheckModel=new OverlappingCheckModel();
      for(let i = 0;i<clienti.length;i++) {
        let c=clienti[i];
        if (c.latitudine && c.longitudine) {
          let overlapFound=this.getOverlap(overlappingCheck,c.latitudine,c.longitudine);
        if(overlapFound===null) {
            let overlapCheck=new OverlappingCheckModel();
            let oce=new OverlapCheckElement();
            oce.lat=c.latitudine;
            oce.lng= c.longitudine;
            oce.clienti.push(c);
            overlappingCheck.elements.push(oce);
            counter++;
            totals++;
          } else {
            overlapFound.clienti.push(c);
          }
          let zonaCountAdded=false;
          zoneCounters.map(function(z){
            if(z.nomeZona===c.zona) {
              z.numeroInZona++;
              zonaCountAdded=true;
            }
          });
          if(!zonaCountAdded) {
            zoneCounters.push({nomeZona:c.zona,numeroInZona:1,lat:c.latitudine,lng:c.longitudine});
          }
        }
      }
      let current=1;
      overlappingCheck.elements.forEach(c => {
          let time=current*50;
          current++;
          let ccpipe=cpipe;
          setTimeout(function(){
            let cccpipe=ccpipe;
            let alertMarker="OK";
            c.clienti.map(function(cliente){
                if(cliente.situazionePartite==='Scoperto'&&alertMarker==='OK') {
                  alertMarker="SCOPERTO";
                } else if(cliente.hasFattureScadute) {
                  alertMarker='SCADUTE';
                }
            });

            let bubbleText='';
            let lat=c.lat;
            let lng=c.lng;
            let titoloMarker =c.clienti.length===1?c.clienti[0].clienteRagioneSociale:"Rilevati più codici zona in questo punto";
            c.clienti.map(function(cliente)
            {
              bubbleText+='<div><a href="/clienti/' + cliente.token + '">' + cliente.clienteRagioneSociale + '</a></div>';
              if(cliente.debitoScaduto!=null&&cliente.debitoScaduto>0) {
                bubbleText+="<div>"+cliente.codiceClienteAS400 +" Scaduto: "+cccpipe.transform(cliente.debitoScaduto,'EUR',true);
                //+c.debitoScaduto.toString();
              }
              if(cliente.debitoScoperto!=null&&cliente.debitoScoperto>0) {
                bubbleText+="<div>"+cliente.codiceClienteAS400 +" Scoperto: "+cccpipe.transform(cliente.debitoScoperto,'EUR',true);
              }
            });

            let marker = main.map.addMarker(
              new google.maps.LatLng(lat, lng),
              titoloMarker,
              bubbleText
              // "<a [routerLink]=\"['/clienti',"+ c.token+"]\">"+ c.clienteRagioneSociale + "</a> "
              ,false,alertMarker
            );
            counter--;
            if(counter===0) {
              main.addingMarkers=false;
              if(zoneCounters.length>0) {
                let maxNumber=0;
                let zonaRiferimento:any;
                zoneCounters.map(function(z){
                  if(z.numeroInZona>maxNumber) {
                    zonaRiferimento=z;
                    maxNumber=z.numeroInZona;
                  }
                });
                if(zonaRiferimento) {
                  main.map.setCenter(new google.maps.LatLng(zonaRiferimento.lat,zonaRiferimento.lng));
                }
              }
            }
          },time);

      });
    }


  }


  private showError(msg: string) {
    this.snackBar.open(msg, 'Chiudi', { duration: 4000 });
  }

  private showInfo(msg: string) {
    this.snackBar.open(msg, 'Chiudi', { duration: 3000 });
  }
}





export class ClientiDataSource extends DataSource<any> {


  constructor(private data: ClienteListItemModel[], private _paginator: MdPaginator, private model: ClienteSearchModel) {
    super();
  }
  connect(): Observable<ClienteListItemModel[]> {

    return Observable.of(this.data);
  }

  disconnect() { }

}



// WEBPACK FOOTER //
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/app/components/clienti/clienti-list.component.ts